<template>

    <div class="outer-wrapper">

        <div v-if=" allTransactions.length < 1 " class="nothing-loaded-wrapper">

            No Transactions!
        </div>
        <div v-else :class=" ListWrapperClasses ">

            <div class="outer-msg" v-for=" ( transaction, transactionKey ) in allTransactions " :key=" transactionKey ">

                <div class="inner-msg" @click=" chooseTransaction( transaction ) ">

                    <div class="transaction-details-wrapper">

                        <div>

                            <p class="merchant-name">{{ transaction.Merchant.name }}</p>
                            <p class="merchant-location">{{ formattedLocation( transaction.MerchantLocation.merchantLocationId ) }}</p>
                        </div>
                        <p class="transaction-price">${{ transaction.Transaction.amount }}</p>
                    </div>
                    <div class="transaction-date-wrapper">

                        <p class="transaction-date">{{ new Date( transaction.Transaction.date ).toLocaleString( 'en-US' ) }}</p>
                    </div>
                </div>
            </div>

        </div>
        <Paginator v-if=" totalPages > 1 " v-bind="{ totalPages, currentPage, changePage }" />
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import Paginator from '../elements/Paginator';

    export default {

        name: 'transactions',
        computed: {

            ...mapGetters({

                allTransactions : 'transactions/allTransactions',
                allLocations    : 'merchant/allLocations',
                totalPages      : 'transactions/totalPages',
                currentPage     : 'transactions/currentPage',
                isLoading       : 'isLoading'
            }),
            ListWrapperClasses(){

                return ( this.totalPages > 1 ) ? 'transaction-list-wrapper' : '';
            }
        },
        methods: {

            chooseTransaction( transaction ){

                // console.log( 'choosing transaction id: ' + transaction.Transaction.transactionId );
            },
            formattedLocation( id ){

                const location = this.allLocations.filter( loc => {

                    if( loc.locationId == id ) return loc;
                })[ 0 ];
                return location != null ? location.name : null;
            },
            changePage( direction ){

                if( !this.isLoading ){

                    this.$store.dispatch( 'transactions/pageTransactions', direction );
                }
            }
        },
        created(){

            this.$store.dispatch( 'transactions/getTransactions' );
        },
        components: {

            Paginator
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        padding-top: 0 !important;
        margin: 0 auto;
        max-width: 450px;
    }

    .transaction-list-wrapper {

        margin-bottom: 75px;
    }

    .outer-msg {

        display: flex;
        align-items: center;

        height: 140px;
        margin-bottom: 10px;
        padding: 5px;
        background-color: white;
        font-family: Arial, Helvetica, sans-serif;
        box-shadow: 0px 3px 8px 0px rgba( 0, 0, 0, 0.5 );
    }
    .inner-msg {

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        cursor: pointer;
        position: relative;
        height: 100%;
        width: 100%;
        padding: 0px 10px;
    }

    .transaction-details-wrapper {

        display: flex;
        justify-content: space-between;
        width: 100%;
        padding-top: 15px;
    }
    .merchant-name {

        font-weight: bold;
        font-size: 18px;
    }
    .merchant-location {

        color: #777;
        font-size: 14px;
    }

    .right-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: center;

        height: 100%;
    }
    .transaction-price {

        font-weight: bold;
        font-size: 24px;
    }

    .transaction-date {

        color: #777;
        text-align: right;
        font-size: 16px;
    }

</style>